import { Box, Divider, Stack, TextField, Typography } from '@mui/material';
import { type AccountInput, type NewAccount } from '@weft/types';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Controller } from 'react-hook-form';

export const BankInfoSection: React.FC = () => {
  const { control, register, formState: { defaultValues } } = useFormContext<AccountInput, unknown, NewAccount>();

  const registerBankName = register('settings.bankDetails.bankName');
  const registerRoutingNumber = register('settings.bankDetails.routingNumber');
  const registerAccountNumber = register('settings.bankDetails.accountNumber');

  return (
    <Stack
      divider={<Divider sx={{ marginY: '20px' }}/>}
    >
      <Stack
        direction="column"
        display="flex"
        paddingX="20px"
      >
        <Typography variant="h6">Bank Info</Typography>
        <Typography
          variant="subtitle1"
          color="text.secondary"
        >
          Update your banking details here
        </Typography>
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-between"
        maxWidth="md"
        display="flex"
        paddingX="20px"
      >
        <Typography
          display="flex"
          flex={7}
        >
          Bank name
        </Typography>

        <Box sx={{
          display: 'flex',
          flex: 8,
        }}
        >
          <Controller
            control={control}
            name={registerBankName.name}
            defaultValue={defaultValues?.settings?.bankDetails?.bankName ?? ''}
            render={({ field }) => (
              <TextField
                size="small"
                fullWidth
                {...field}
              />
            )}
          />
        </Box>
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-between"
        maxWidth="md"
        display="flex"
        paddingX="20px"
      >
        <Typography
          display="flex"
          flex={7}
        >
          Routing number
        </Typography>

        <Box sx={{
          display: 'flex',
          flex: 8,
        }}
        >
          <Controller
            control={control}
            name={registerRoutingNumber.name}
            defaultValue={defaultValues?.settings?.bankDetails?.routingNumber ?? ''}
            render={({ field }) => (
              <TextField
                size="small"
                fullWidth
                {...field}
              />
            )}
          />
        </Box>
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-between"
        maxWidth="md"
        display="flex"
        paddingX="20px"
      >
        <Typography
          display="flex"
          flex={7}
        >
          Account name
        </Typography>

        <Box sx={{
          display: 'flex',
          flex: 8,
        }}
        >
          <Controller
            control={control}
            name={registerAccountNumber.name}
            defaultValue={defaultValues?.settings?.bankDetails?.accountNumber ?? ''}
            render={({ field }) => (
              <TextField
                size="small"
                fullWidth
                {...field}
              />
            )}
          />
        </Box>
      </Stack>
    </Stack>
  );
};